import { Config } from "~/config";
import { IAuthContextConfig } from "~/ad-authentication/Interfaces";
import { VssNavigation } from "~/navigation";

export const authConfig = {
    getAuthority: (): string => {
        const tenantId = Config.getValue("UI:TENANT_ID");
        const loginURL = Config.getValue("UI:MICROSOFT_AAD_LOGIN_URL");
        return loginURL + "/" + tenantId;
    },

    getReplyToURL: (): string => {
        let replyToUrl = VssNavigation.getHubUrl();
        if (!replyToUrl) {
            replyToUrl = VssNavigation.getCurrentUrl();
        }
        return `reply_to=${replyToUrl}`;
    },

    getAadConfig: (): IAuthContextConfig => {
        const AadConfig: IAuthContextConfig = {
            clientId: Config.getValue("UI:AD_CLIENT_ID"),
            redirectUri: Config.getValue("UI:AD_REDIRECT_URI"),
            cacheLocation:
                Config.getValue("UI:CACHE_LOCATION") === "sessionStorage"
                    ? "sessionStorage"
                    : "localStorage",
            loadFrameTimeout: 60000,
            state: authConfig.getReplyToURL(),
            authority: authConfig.getAuthority(),
        };
        return AadConfig;
    },

    getLoginRequest: () => {
        const loginRequest = {
            scopes: [authConfig.getAadConfig().clientId + "/.default"],
            redirectUri: Config.getValue("UI:AD_REDIRECT_URI"),
            authority: authConfig.getAuthority(),
            state: authConfig.getReplyToURL(),
        };
        return loginRequest;
    },
};